import {AttendanceContext} from './extractAttendanceContext'

export type AttendanceContextSendResolution = {
  attendanceContext: AttendanceContext | null
  clearStoredContext: boolean
}

type ResolveAttendanceContextParams = {
  explicitContext?: AttendanceContext | null
  isDisambiguationPick: boolean
}

/** Only forward attendance context when the user picks a disambiguation option. */
export function resolveAttendanceContextForSend({
  explicitContext,
  isDisambiguationPick,
}: ResolveAttendanceContextParams): AttendanceContextSendResolution {
  if (isDisambiguationPick) {
    return {
      attendanceContext: explicitContext ?? null,
      clearStoredContext: false,
    }
  }

  return {
    attendanceContext: null,
    clearStoredContext: true,
  }
}
